module.exports = __webpack_public_path__ + "img/isotipo-aliaddo.52c339f9.svg";